module.exports = __webpack_public_path__ + "img/11_fineTeam_vip.ded9ccf7.png";